import { CreateBooking } from '@/models/bookings';
import { State } from './state';
import { User } from '@/models/auth';

export const GETTERS = {
  GET_API_KEY: 'GET_API_KEY',
  GET_IS_AUTHENTICATED: 'GET_IS_AUTHENTICATED',
  GET_IS_LOGOUT_FROM_MS: 'GET_IS_LOGOUT_FROM_MS',
  GET_BOOKING_URL: 'GET_BOOKING_URL',
  GET_CREATE_BOOKING: 'GET_CREATE_BOOKING',
  GET_USER: 'GET_USER',
};

export default {
  [GETTERS.GET_API_KEY]: (state: State): string => {
    return state.apiKey;
  },

  [GETTERS.GET_IS_AUTHENTICATED]: (state: State): boolean => {
    return !!state.apiKey;
  },

  [GETTERS.GET_IS_LOGOUT_FROM_MS]: (state: State): boolean => {
    return state.logout_from_ms;
  },

  [GETTERS.GET_BOOKING_URL]: (state: State): string => {
    return state.bookingUrl;
  },

  [GETTERS.GET_CREATE_BOOKING]: (state: State): CreateBooking | undefined => {
    return state.createBooking;
  },

  [GETTERS.GET_USER]: (state: State): User | undefined => {
    return state.user;
  },
};
